// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__wasx2","scrollableSection":"styles_scrollableSection__jDHSn"};